import { PmsAddressValue } from "types/landlord/address";

// Mirrors the Rental Information override wording (see
// shared/app/RentalInfoForm/constants.ts). Exact product copy for the General
// section is still pending design confirmation (CRM-1089, assumption 3).
export const pmsSyncedTooltip = (label: string) =>
  `${label} is synchronized with PMS. You can manually edit the field by
  disabling synchronization for this field. To do this, click 'Edit manually'
  option`;

export const pmsManualTooltip = (label: string) =>
  `${label} is currently edited manually. You can enable synchronization by
  clicking 'Sync with PMS' option`;

// Street, apartment, city, state and zip share one override, so the tooltip
// and the PMS Value reference talk about the address as a whole.
export const ADDRESS_LABEL = "Address";

export const formatPmsAddress = (address?: PmsAddressValue) => {
  if (!address) return "";

  const street = [address.address1, address.address2]
    .filter(Boolean)
    .join(", ");
  const region = [address.state_or_province, address.postal_code]
    .filter(Boolean)
    .join(" ");

  return [street, address.city, region].filter(Boolean).join(", ");
};
